import { compare } from 'specificity';
import findAllFor from '../filters/find-all-for';

const getMatchedContenteditableType = (node) => {
  const constraints = findAllFor(node);

  const filteredConstraints = constraints.reduce((acc, constraint) => {
    const { contenteditable, element: selector } = constraint;

    if (!contenteditable) return acc;

    // Each constraint could have selector string written for multiple
    // elements so we have to find the most specific from matched ones
    let highestSpecificityMatchedSelector;

    if (selector.includes(',')) {
      const matchedSelectors = selector.split(',').filter((sel) => node.matches(sel.trim()));

      highestSpecificityMatchedSelector = matchedSelectors.sort(compare).pop();
    } else {
      highestSpecificityMatchedSelector = selector;
    }

    return [
      ...acc,
      {
        ...constraint,
        element: highestSpecificityMatchedSelector,
      },
    ];
  }, []);

  const highestSpecificityConstraint = filteredConstraints
    .sort((a, b) => compare(a.element, b.element))
    .pop();

  if (!highestSpecificityConstraint) return null;

  return highestSpecificityConstraint.contenteditable || null;
};

export default getMatchedContenteditableType;
